import { creatorShowcase } from '@/mocks/home';

export default function CreatorSection() {
  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4">
            优质创作者
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            遇见最优秀的创作者
          </h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">
            他们用镜头记录世界，用创意点亮生活
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {creatorShowcase.map((creator, index) => (
            <div
              key={index}
              className="group p-6 rounded-2xl bg-background-50 border border-background-200/70 hover:-translate-y-1 transition-all duration-300"
            >
              <div className="relative w-20 h-20 mx-auto mb-4">
                <div className="w-full h-full rounded-full bg-background-200 overflow-hidden">
                  <img
                    src={creator.avatar}
                    alt={`91short创作者 ${creator.name}`}
                    className="w-full h-full object-cover"
                    title={`91short创作者 - ${creator.name}`}
                  />
                </div>
                <div className="absolute -bottom-1 -right-1 w-7 h-7 rounded-full bg-primary-500 flex items-center justify-center border-2 border-background-50">
                  <i className="ri-check-line text-background-50 text-xs"></i>
                </div>
              </div>

              <div className="text-center">
                <h3 className="text-base font-heading font-semibold text-foreground-950 mb-1">
                  {creator.name}
                </h3>
                <span className="inline-block px-2.5 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
                  {creator.category}
                </span>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  {creator.description}
                </p>
                <div className="flex items-center justify-center gap-2 text-sm">
                  <span className="text-foreground-500">粉丝</span>
                  <span className="font-semibold text-primary-600">{creator.followers}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}